import { CSSProp } from 'styled-components';

// ----------------------------------------------------------------------

const colors = {
  grayscale: {
    50: '#F7F8FA',
    100: '#F2F3F5',
    200: '#C3CAD9',
    300: '#ADB8CC',
    400: '#7D8FB3',
    500: '#6B7A99',
    600: '#4D5E80',
    700: '#3E4F70',
    800: '#22345E'
  },
  primary: {
    300: '#A0BCE4',
    400: '#3361FF',
    500: '#0044FC'
  },
  info: '#3361FF',
  error: '#E62E2E',
  blue: '#33BFFF',
  green: '#29CC39',
  yellow: '#FF9F43',
  pink: '#FF2D55',
  purple: '#AF52DE'
};

const headers = {
  height: '60px'
};

const nav = {
  desktop: '240px',
  active: '80px'
};

export const breakpoints: {[key: string]: number}  = {
  sm: 465,
  md: 768,
  slg: 845,
  mlg: 1055,
  lg: 1150,
  xl: 1375,
  xxl: 1535
};

export const media = (Object.keys(breakpoints) as Array<keyof typeof breakpoints>).reduce(
  (acc, key) => {
    acc[key] = (style: string) => `@media screen and (max-width: ${breakpoints[key]}px) {
      ${style}
    }`
    return acc;
  },
  {} as { [key in keyof typeof breakpoints] : (style: string) => CSSProp}
);

const theme = { colors, headers, nav, media };

export default theme;
export type Theme = typeof theme;